import { DataTableColumnHeader } from "components/ui/DataTable";
import { ColumnDef } from "@tanstack/react-table";
import {
  DataTableActions,
  IDataTableAction,
} from "components/ui/DataTableActions";

import { IHubChecklistUser } from "interfaces/Hub";
import { usePermissions } from "hooks";

interface IColumnProps {
  deleteFunc: (toDelete: IHubChecklistUser) => void;
}

export function useColumns({ deleteFunc }: IColumnProps) {
  const { checkUserPermission } = usePermissions();

  const columns: ColumnDef<IHubChecklistUser>[] = [
    {
      id: "Id",
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Id" />
      ),
      cell: ({ row: { original: data } }) => {
        return `${data.id}`;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "name",
      accessorKey: "name",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Motorista" />
      ),
      cell: ({ row: { original: data } }) => {
        return `${data.name}`;
      },
      enableSorting: false,
      enableHiding: true,
    },

    {
      id: "email",
      accessorKey: "email",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="E-mail" />
      ),
      cell: ({ row: { original: data } }) => {
        return data.email;
      },
      enableSorting: false,
      enableHiding: true,
    },

    
    {
      id: "actions",
      cell: ({ row: { original: data } }) => {
        const actions: IDataTableAction[] = [
          {
            name: "Editar",
            route: `/settings/hub-checklist-user/edit/${data.id}`,
            hasPermission: checkUserPermission("all"),
          },
          {
            name: "Excluir",
            action: () => deleteFunc(data),
            hasPermission: checkUserPermission("all"),
          },
        ];
        return <DataTableActions actions={actions} />;
      },
    },
  ];

  return { columns };
}
